import React from 'react';
import ReactTable from "react-table";
import { Row, Col, Button } from 'react-bootstrap';

import "react-table/react-table.css";


import 'bootstrap/dist/css/bootstrap.css';
import { uniq } from 'underscore';
import FontAwesome from 'react-fontawesome';
import constants from '../.././util/constants';
import axios from 'axios';
import { export2Excel, filterMultiple, filterNumber, getFilteredData, setDataForExpansion, getSum, getExpander, getLabelColumn } from '../../gridHelpers/gridHelpers';
import LoadingSpinner from '../../LoadingSpinner';
import NPHelpButton from '../../NPHelpButton';
import NPReactTable from '../../NPReactTable';
import NPBarChart from '../NPBarChart';
import * as Grants from '../.././util/grants';
import { hasGrant } from '../.././util/grantHelper';
import './style.scss';
import moment from 'moment';
import _ from 'underscore';
import ReactGA from 'react-ga';
import * as Convert from '../../util/unitConversion';



const { API_BASE_URL } = constants;

class OrderDataTable extends React.Component {
    constructor(props) {
        super(props);    
        this.resetState = this.resetState.bind(this);
        this.tell = this.tell.bind(this);
        this.help = this.help.bind(this);
        this.excelExport = this.excelExport.bind(this);
        this.updateSums = this.updateSums.bind(this);
        this.getcolumns = this.getcolumns.bind(this);
        this.getClearedState = this.getClearedState.bind(this);
        this.clearCurrentExpandforAll = this.clearCurrentExpandforAll.bind(this);
        this.getData = this.getData.bind(this);
        this.resetState = this.resetState.bind(this);
        this.state = this.getClearedState();
        this.getDataForChart = this.getDataForChart.bind(this);
        this.daysInMonth = this.daysInMonth.bind(this);
        this.getMonthFromExmill = this.getMonthFromExmill.bind(this);
        //this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
        this.getData('', true);
    }

    componentWillReceiveProps(nextProps) {
         if (nextProps.ccr !== this.props.ccr) {
             let filters=this.state.filtered;
            let clientId=filters.find(f=>f.id==='CLIENT_CODE_REGIONAL');
            if (clientId && clientId.id!=nextProps.ccr)
            {
                clientId.value=nextProps.ccr;
            }
            else if (clientId===undefined && nextProps.ccr!='')
            {
                filters.push({id:'CLIENT_CODE_REGIONAL', value:nextProps.ccr})
            }
            this.setState({filtered:filters, page: 0});
            let self=this;
            setTimeout(() => {
                self.updateSums();
            }, 200);            
        };
    }

    daysInMonth(month, year){
        return new Date(year, month, 0).getDate();
    }

    getMonthFromExmill(exmill){
        var xYear = exmill.substring(0,4);
        var xMonth = exmill.substring(5,7);
        var xDay = exmill.substring(8,10);
        var days = this.daysInMonth(xMonth, xYear);
        var month = parseInt(xDay) + 3 > days ? ("0" + (parseInt(xMonth) + 1)).slice(-2) : xMonth;
        return month;
    }

    getDataForChart(data)
    {
        Array.prototype.groupBy = function(prop) {
            return this.reduce(function(groups, item) {
              var val = item[prop];
              groups[val] = groups[val] || [];
              groups[val].push(item);
              return groups;
            }, {});
          }
        let test=data.filter(d=>d.EXMILL && d.EXMILL.length===10).map(d=>({
            Year:d.EXMILL.substring(0,4), 
            Month:this.getMonthFromExmill(d.EXMILL),
            YearMonth:d.EXMILL.substring(0,4)+this.getMonthFromExmill(d.EXMILL),
            WEIGHT_UC: d.WEIGHT_UC,
            STOCK_WEIGHT_UC:d.STOCK_WEIGHT_UC,
            SHIPPED_WEIGHT_UC:d.SHIPPED_WEIGHT_UC
        }));

        const sum=(data, field) =>
        {
            if (!data || data.length===0) return 0;
            const doSum = (total, num) => { return total + num};
            return Math.round([...data.map((v => v[field]))].reduce(doSum));
        }
        let result=[];
        let firstMonth = moment().subtract(6,'months').format('YYYYMM');;
        let lastMonth = moment().add(5,'months').format('YYYYMM');
        for(var i=firstMonth; i<=lastMonth; i++)
        {
            let testmonth=parseInt(i.toString().substring(4,6));
            if (testmonth>0 && testmonth<13)
            {
                let tmp=test.filter(t=>t.YearMonth==i);

                let year=(tmp.length>0 && tmp[0].Year) || parseInt(i.toString().substring(0,4));
                let month= (tmp.length>0 && tmp[0].Month) || testmonth;
                
                result.push({
                    Year:year, 
                    Month:month,
                    Stock_Weight:tmp.length>0 ? sum(tmp,"STOCK_WEIGHT_UC") : 0,
                    Shipped_Weight:tmp.length>0 ? sum(tmp,"SHIPPED_WEIGHT_UC") : 0,
                    Ordered_Weight:tmp.length>0 ? sum(tmp,"WEIGHT_UC") : 0
                });
            }
        }
        return result;
    }


    getSums(data)
    {
      let result= !data ? {} : {
        quantityTotal:getSum(data, "QUANTITY"),
        weightTotal:getSum(data, "WEIGHT_UC"),
        stockquantityTotal:getSum(data, "STOCK_QUANTITY"),
        stockweightTotal:getSum(data, "STOCK_WEIGHT_UC"),
        shippedquantityTotal:getSum(data, "SHIPPED_QUANTITY"),
        shippedweightTotal:getSum(data, "SHIPPED_WEIGHT_UC"),
      };
      return result;
    }
  
    updateSums() {
      let data=getFilteredData(this.reactTable.getReactTable());
      let states=this.getSums(data);
      let orderGraphData=this.getDataForChart(data);
      states["orderGraphData"]=orderGraphData;
      this.setState(states);      
    }



    clearCurrentExpandforAll() {
        let d = getFilteredData(this.reactTable.getReactTable());
        this.currentExpand = '';
        d.forEach(dt => {
            dt.TAG = undefined;
        });
    }

    resetState() {
        this.setState(this.getClearedState());
        setTimeout(()=>{this.updateSums();},200);
            
    }


    getcolumns() {
        let self=this;
        const helpNode = (
            <div>
                <h3>Buttons</h3>

                <h4>Reset</h4>
                <p>Resets filters, sorting, column widths and navigates to first page.</p>

                <h4>Excel</h4>
                <p>Exports the data to excel according to filters and sorting.</p>

                <h3>Filters</h3>

                <p>There are fields at the top of the table that can be used for filtering</p>

                <p>
                    If a text box for a column is empty, no filtering for that column will be done.<br />
                    If the data is left-aligned and the text box is not empty, the filter will remove rows that do not contain the text in the text box<br />
                    It is possible to use multiple filters for text based values by writing a comma, for example "Ordered, Being produced"<br /><br />
                    Examples follows for right-aligned (numbers):<br />
                    Empty text box, no filtering.<br />
                    <strong>&lt; 10</strong> view rows with data that is less than 10<br />
                    <strong>&gt; 10</strong> view rows with data that is more than 10<br />
                    <strong>20-30</strong> view rows with data that is between 20 and 30.
                </p>
            </div>
            );



        return ([
            {
                Header: "",
                maxWidth: 30,
                Filter: ({ filter, onChange }) =>
                    <NPHelpButton content={helpNode} title="Help" />
            },
            {
                Header: "Order information",
                headerStyle: { background: '#DDDDDD' },
                columns: [
                    {   
                        Header: "Ship no earlier",
                        accessor: "SHIP_NO_EARLIER",
                        maxWidth: 100,
                    },
                    {
                        Header: "Ship no later",
                        accessor: "SHIP_NO_LATER",
                        maxWidth: 100,
                    },
                    {
                        show: hasGrant(Grants.TYPES.General_ExpandOrderDetails),
                        expander: true,
                        width: 35,
                        Expander: ({ isExpanded, ...row }) =>
                            getExpander(row,'ORDER_COMBO',this,isExpanded),
                            style: {
                            cursor: "pointer",
                            textAlign: "center",
                            userSelect: "none"
                        },
                      },
                      {
                        Header: "Number",
                        accessor: "ORDER_COMBO",
                        maxWidth: 80,
                      }, 
                    {
                        expander: true,
                        width: 35,
                        Expander: ({ isExpanded, ...row }) =>
                        getExpander(row,'CLIENT_CODE_REGIONAL',this,isExpanded),
                        style: {
                          cursor: "pointer",
                          textAlign: "center",
                          userSelect: "none"
                        },
                      }, 
                    {
                        Header: "Client",
                        accessor: "CLIENT_CODE_REGIONAL",
                        maxWidth: 80,
                    },                     
                    {
                        Header: "Name",
                        accessor: "CLIENT_NAME",
                        maxWidth: 80,
                    },                     {
                        Header: "Call off",
                        accessor: "CALL_OFF",
                        maxWidth: 50,
                        style: { "textAlign": "right" },
                        filterMethod: filterNumber,
                    },
                    {
                        Header: "Customer po",
                        accessor: "CUSTOMER_PO",
                        maxWidth: 120,
                    },
                    {
                        Header: "Agent ref",
                        accessor: "SALES_AGENT_COMBO",
                        maxWidth: 120,
                    },
                    {
                        show: hasGrant(Grants.TYPES.General_ExpandOrderStatus),
                        expander: true,
                        width: 35,
                        Expander: ({ isExpanded, ...row }) =>
                        getExpander(row,'ORDER_STATUS',this,isExpanded),
                        style: {
                          cursor: "pointer",
                          textAlign: "center",
                          userSelect: "none"
                        },
                      },
                    {
                        Header: "Status",
                        accessor: "ITEM_STATUS",
                        maxWidth: 90,
                    },
                    {
                        Header: "FSC",
                        accessor: "FSC",
                        maxWidth: 50,
                        style: { textAlign: "center" },
                        filterMethod: filterNumber,
                    },
                    {
                        Header: "PEFC",
                        accessor: "PEFC",
                        maxWidth: 50,
                        style: { textAlign: "center" },
                        filterMethod: filterNumber,
                    },
                    {
                        Header: "CW",
                        accessor: "CW_MARK",
                        maxWidth: 50,
                        style: { textAlign: "center" },
                        filterMethod: filterNumber,
                    },
                    {
                        Header: "Issued",
                        accessor: "DATE_ISSUED",
                        maxWidth: 80,
                    },
                    // {
                    //     Header: "EXMILL",
                    //     accessor: "EXMILL",
                    //     maxWidth: 80,
                    // },
                ]
            },
            {
                Header: "Product",
                headerStyle: { background: '#EEEEEE' },
                columns: [
                    {
                        expander: true,

                        width: 35,
                        Expander: ({ isExpanded, ...row }) =>
                        getExpander(row,'PRODUCT_CODE',this,isExpanded),
                        style: {
                            cursor: "pointer",
                            textAlign: "center",
                            userSelect: "none"
                        },
                    },
                    {
                        Header: "Code",
                        accessor: "PRODUCT_CODE",
                        minWidth: 140,
                    },
                    {
                        Header: "Product Name",
                        accessor: "GRADE_DESCRIPTION",
                        maxWidth: 170,
                    },
                    {
                        Header: "Description",
                        accessor: "ADESCRIPTION_ALT",
                        maxWidth: 80,
                    },
                    {
                        Header: (<Convert.TextTo value_metric={"Format (mm)"} value_imperial={"Format (in)"}/>),
                        accessor: "FORMAT_UC",
                        filterMethod: filterNumber,
                        maxWidth: 100,
                    },
                    {
                        Header: (<Convert.TextTo value_metric={"GSM"} value_imperial={"Basis Weight"}/>),
                        accessor: "BASIS_WEIGHT_UC",
                        filterMethod: filterNumber,
                        minWidth: 100,
                        id:'BASIS_WEIGHT_UC',
                        Cell: row => (
                            <div><Convert.AddSymbol check={row.original.BASIS_WEIGHT_UC}/>{row.original.BASIS_WEIGHT_UC}</div>
                        )
                    },
                    {
                        Header: (<Convert.TextTo value_metric={"Width (mm)"} value_imperial={"Width (in)"}/>),
                        accessor: "WIDTH_UC",
                        filterMethod: filterNumber,
                        maxWidth: 80,
                    },

                ]
            },
            {
                Header: "Info",
                headerStyle: { background: '#DDDDDD' },
                columns: [
                    {
                        Header: "Quantity",
                        accessor: "QUANTITY",
                        maxWidth: 100,
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                              <strong>{this.state.quantityTotal}</strong>
                            </span>
                          ),
                        style: { "textAlign": "right" }
                    },
                    {
                        Header: (<Convert.TextTo value_metric={"Weight (kg)"} value_imperial={"Weight (lb)"}/>),
                        accessor: "WEIGHT_UC",
                        maxWidth: 100,
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                              <strong>{this.state.weightTotal}</strong>
                            </span>
                          ),
                        style: { "textAlign": "right" }
                    },
                    {
                        Header: "Stock quantity",
                        accessor: "STOCK_QUANTITY",
                        maxWidth: 100,
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                              <strong>{this.state.stockquantityTotal}</strong>
                            </span>
                          ),
                        style: { "textAlign": "right" }
                    },                     
                    {
                        Header: (<Convert.TextTo value_metric={"Stock weight (kg)"} value_imperial={"Stock weight (lb)"}/>),
                        accessor: "STOCK_WEIGHT_UC",
                        maxWidth: 120,
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                              <strong>{this.state.stockweightTotal}</strong>
                            </span>
                          ),
                        style: { "textAlign": "right" }
                    }, 
                    {
                        Header: "Shipped quantity",
                        accessor: "SHIPPED_QUANTITY",
                        minWidth: 110,
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                              <strong>{this.state.shippedquantityTotal}</strong>
                            </span>
                          ),
                        style: { "textAlign": "right" }
                    },
                    {
                        Header: (<Convert.TextTo value_metric={"Shipped weight (kg)"} value_imperial={"Shipped weight (lb)"}/>),
                        accessor: "SHIPPED_WEIGHT_UC",
                        minWidth: 120,
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                              <strong>{this.state.shippedweightTotal}</strong>
                            </span>
                          ),
                        style: { "textAlign": "right" }
                    },
                    getLabelColumn("Loading no","DISTINCT_LOADING_NO",100,self,true),
                    getLabelColumn("Invoice no","DISTINCT_INVOICE_NO",100,self,true),
                ]
            },

        ]);
    }

    getClearedState() {

        return ({
            sorted: [],
            page: 0,
            pageSize: 10,
            expanded: {},
            resized: [],
            filtered: [],
            showModal: false,
            selectedProductCode: '',
            productCodeFilter: null,
            clientFilter: null,
            loaded:false,
        });
    }

    help() {
        alert('Buttons:\nReset: Resets filters, sorting, column widths and sets page to page 1.\n' +
            'Excel: Exports the data to excel according to filters and sorting.\n\n' +
            'Filters:\nBelow the columns filter we have input text boxes that can be used for filtering\n' +
            'If a text-box for a column is empty, no filtering for that column will be done.\n' +
            'If the data is left-aligned and the text-box is not empty, the filter will remove rows that do not contain the the text in the text-box.\n' +
            'Examples follows for right-aligned (numbers):\n' +
            'Empty text-box, no filtering.\n>10 filters rows with column data with 10 or less\n' +
            '<10 filters rows with column data 10 or more\n20-30 filters rows with data that is not between 20 and 30.');
    }

    excelExport() {
        export2Excel(this.props.apiToken, this.reactTable.getReactTable(), "Dashboard_orders.xlsx");
        this.GAtrackHandler();
    }
    GAtrackHandler(e) {
        console.log("order dash");
        ReactGA.event({
          category: "User action",
          action: "Order was exported as Excel from dashboard",
        });  
    }

    tell(txt, row) {
        setDataForExpansion(txt, row, this.props.apiToken, this);
      }

    getOptionLabelAndValue(values) {
        values.sort();
        values = uniq(values);
        return values.map(v => ({ value: v, label: v }));
    }



    getData(ccr, fromConstructor) {
        let self = this;
        
        const header = {
            'Authorization': 'Bearer ' + this.props.apiToken,
            'Accept': 'application/octet-stream'
        };

        let filter= (ccr === undefined || ccr === '')  ? '' : '?ccr=' + ccr;
        
        this.props.setIsLoadingForCCRPicker(true);

        if(fromConstructor) {
            self.state['isLoading'] = true;
        } else {
            self.setState({ isLoading: true });
        }
        

        axios.get(API_BASE_URL + 'Dashboard/GetOrderData' + filter, { headers: header })
            .then(result => {
                let states=self.getSums(result.data);       
                let orderGraphData = this.getDataForChart(result.data);
                self.setState({ loaded: true, data: result.data, orderGraphData, ...states, isLoading: false });
                this.props.setIsLoadingForCCRPicker(false);
            }).catch(response => { this.props.setIsLoadingForCCRPicker(false); });
    }

    render() {
        const { apiToken } = this.props;
        const data = this.state.data;

        if (!data || this.state.isLoading) {
            return <LoadingSpinner isLoading={true} />
        }
        let self=this;
        let orderGraphData=this.state.orderGraphData;        
        let orderGraphNode=null;
        // console.log("this.state.filtered",this.state.filtered);
        // console.log(this.state.filtered.find(f=>f.id==='CLIENT_CODE_REGIONAL'));
        if(orderGraphData && orderGraphData.length > 0) {
          orderGraphNode = (<NPBarChart graphData={orderGraphData} />);
        }
        
       
        return (
            <Row className="margin-top-10">
                <Col xs={12} className="margin-top-10">
                    <Button bsStyle="primary" bsSize="small" onClick={this.resetState}>Reset</Button>
                    {hasGrant(Grants.TYPES.General_ExportToExcel) && <Button bsStyle="primary" bsSize="small" className="margin-left-10" onClick={this.excelExport}>Excel</Button>}
                    <Button bsStyle="primary" bsSize="small" className="pull-right" onClick={() => { this.getData('', false); }}>Refresh</Button>
                    {/* <Col xs={1}><button onClick={this.resetState}>Reset</button></Col>
                    <Col xs={1}><button onClick={this.excelExport}>Excel</button></Col> */}
                </Col>
                
                <Col sm={6} md={8} className="margin-top-10">
                    <NPReactTable
                        className="np-react-table"                        
                        data={data}
                        ref={(r) => { this.reactTable = r }}
                        columns={this.getcolumns()}
                        defaultFilterMethod={filterMultiple}
                        filterable
                        filterAll
                        defaultPageSize={10}
                        // Controlled props
                        sorted={this.state.sorted}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        expanded={this.state.expanded}
                        resized={this.state.resized}
                        filtered={this.state.filtered}
                        // Callbacks
                        onSortedChange={sorted => this.setState({ sorted, expanded: {} })}
                        onPageChange={
                            page => {
                                this.clearCurrentExpandforAll();
                                this.setState({ page, expanded: {} });
                            }

                        }
                        
                        onPageSizeChange={(pageSize, page) => {
                            this.clearCurrentExpandforAll();
                            this.setState({ page, pageSize, expanded: {} });
                        }
                        }
                        onResizedChange={resized => this.setState({ resized })}
                        onFilteredChange={filtered => {
                            this.updateSums();
                            this.clearCurrentExpandforAll();
                            this.setState({ filtered, page: 0, expanded: {} })
                        }
                        }
                        SubComponent={row => {
                            let r = row.original;
                            let t = 'EXP_' + r.TAG;
                            if (r.TAG && r.TAG !== '' && r[t]) {
                                return r[t];
                            }
                        }
                        }
                    />
                </Col>
                <Col sm={6} md={4}>
                    {orderGraphNode}
                </Col>
            </Row>
        );
    }
}

export default OrderDataTable;